import BaseService from './BaseService';
import apiClient from '../plugins/axios';

/**
 * RAG Service
 */
class RagService extends BaseService {
  constructor() {
    super('rag');
  }

  /**
   * List all RAGs
   * @returns {Promise}
   */
  async getAllRags() {
    try {
      const response = await apiClient.get('/rag');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Create a new RAG (source)
   * @param {FormData|Object} ragData - RAG data (multipart/form-data for file uploads)
   * @param {string} ragData.name - RAG name (required)
   * @param {string} [ragData.description] - RAG description (optional)
   * @param {string} ragData.collection_id - Collection ID (required)
   * @param {string} ragData.source_type - Source type: 'web' or 'document' (required)
   * @param {File} [ragData.file] - Document file for upload (required for document type)
   * @returns {Promise<Object>} API response
   */
  async createRag(ragData) {
    try {
      const config = { headers: { 'Content-Type': ragData instanceof FormData ? 'multipart/form-data' : 'application/json' } };

      const response = await apiClient.post('/rag', ragData, config);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get RAG details
   * @param {string} id - RAG ID
   * @returns {Promise}
   */
  async getRagById(id) {
    try {
      const response = await apiClient.get(`/rag/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update RAG
   * @param {string} id - RAG ID
   * @param {Object} ragData - RAG data to update
   * @returns {Promise}
   */
  async updateRag(id, ragData) {
    try {
      const response = await apiClient.put(`/rag/${id}`, ragData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Delete RAG
   * @param {string} id - RAG ID
   * @returns {Promise}
   */
  async deleteRag(id) {
    try {
      const response = await apiClient.delete(`/rag/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get RAGs by collection ID
   * @param {string} collectionId - Collection ID
   * @returns {Promise}
   */
  async getRagsByCollectionId(collectionId) {
    try {
      const response = await apiClient.get(`/rag?collection_id=${collectionId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new RagService();
